import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import * as fromI18n from '../../../../../i18n/reducers';
import { I18nComponent } from '../../../../../i18n/containers/i18n.component';

@Component({
  selector: 'app-client-edit',
  templateUrl: './client-edit.component.html',
  styleUrls: ['./client-edit.component.scss']
})
export class ClientEditComponent extends I18nComponent {
  public id: any = null;

  constructor(
    readonly store: Store<fromI18n.State>,
    readonly translate: TranslateService,
    private route: ActivatedRoute
  ) {
    super(store, translate);
  }

  ngOnInit() {
    super.ngOnInit();

    this.id = this.route.snapshot.paramMap.get("id");
  }
}
